// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-content {
  --keyboard-offset: 0px !important;
}

#map {
  position: relative;
  width: 100%;
  height: 90%;
  z-index: 0;
}

#centerMarkerImage {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  width: 32px;
  height: 24px;
  z-index: 1;
}

#map {
  height: 90%;
  margin: 0;
}

#map {
  position: relative;
  cursor: default !important;
}

#map div {
  cursor: default !important;
}

.address-tip {
  z-index: 999999999 !important;
  position: absolute;
  top: 40%;
  left: 10%;
  margin: -40px 0 0 -11px;
  width: 85%;
  height: 60px;
  border-radius: 8px;
  background-color: #fdfdfd;
  border-color: #5c636d;
  border-style: solid;
  border-width: 2px;
  color: black;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  padding: 3px;
}

.marker {
  width: 22px;
  height: 40px;
  display: block;
  content: " ";
  z-index: 999999999 !important;
  position: absolute;
  top: 50%;
  left: 50%;
  margin: -40px 0 0 -11px;
  background: url("https://maps.gstatic.com/mapfiles/api-3/images/spotlight-poi_hdpi.png");
  background-size: 22px 40px; /* Since I used the HiDPI marker version this compensates for the 2x size */
  pointer-events: none; /* This disables clicks on the marker. Not fully supported by all major browsers, though */
}

app-google-map {
  display: block;
  width: 100%;
  height: 100%;
}

.mini {
  height: 200px;
  overflow: hidden;
  position: sticky !important;
  top: 0px;
  z-index: 100;
}

.maxi {
  height: 100%;
  width: 100%;
  position: relative;
  overflow: hidden;
}`, "",{"version":3,"sources":["webpack://./src/app/components/location/google-map/google-map.component.scss"],"names":[],"mappings":"AAAA;EACI,iCAAA;AACJ;;AAEA;EACI,kBAAA;EACA,WAAA;EACA,WAAA;EACA,UAAA;AACJ;;AACA;EACI,kBAAA;EACA,OAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;AAEJ;;AACA;EACI,WAAA;EACA,SAAA;AAEJ;;AAAA;EACI,kBAAA;EACA,0BAAA;AAGJ;;AAAA;EACI,0BAAA;AAGJ;;AAAA;EACI,6BAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,uBAAA;EACA,UAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,qBAAA;EACA,mBAAA;EACA,iBAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,YAAA;AAGJ;;AAAA;EACI,WAAA;EACA,YAAA;EACA,cAAA;EACA,YAAA;EACA,6BAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,uBAAA;EACA,wFAAA;EACA,0BAAA,EAAA,2EAAA;EACA,oBAAA,EAAA,0FAAA;AAGJ;;AAAA;EACI,cAAA;EACA,WAAA;EACA,YAAA;AAGJ;;AACA;EACI,aAAA;EAEA,gBAAA;EAGA,2BAAA;EACA,QAAA;EACA,YAAA;AADJ;;AAIA;EACI,YAAA;EACA,WAAA;EACA,kBAAA;EACA,gBAAA;AADJ","sourcesContent":["ion-content {\n    --keyboard-offset: 0px !important;\n}\n\n#map {\n    position: relative;\n    width: 100%;\n    height: 90%;\n    z-index: 0;\n}\n#centerMarkerImage {\n    position: absolute;\n    left: 0;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    margin: auto;\n    width: 32px; // image width\n    height: 24px; // image height\n    z-index: 1;\n}\n\n#map {\n    height: 90%;\n    margin: 0;\n}\n#map {\n    position: relative;\n    cursor: default !important;\n}\n\n#map div {\n    cursor: default !important;\n}\n\n.address-tip {\n    z-index: 999999999 !important;\n    position: absolute;\n    top: 40%;\n    left: 10%;\n    margin: -40px 0 0 -11px;\n    width: 85%;\n    height: 60px;\n    border-radius: 8px;\n    background-color: #fdfdfd;\n    border-color: #5c636d;\n    border-style: solid;\n    border-width: 2px;\n    color: black;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    font-size: 14px;\n    padding: 3px;\n}\n\n.marker {\n    width: 22px;\n    height: 40px;\n    display: block;\n    content: \" \";\n    z-index: 999999999 !important;\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    margin: -40px 0 0 -11px;\n    background: url(\"https://maps.gstatic.com/mapfiles/api-3/images/spotlight-poi_hdpi.png\");\n    background-size: 22px 40px; /* Since I used the HiDPI marker version this compensates for the 2x size */\n    pointer-events: none; /* This disables clicks on the marker. Not fully supported by all major browsers, though */\n}\n\napp-google-map {\n    display: block;\n    width: 100%;\n    height: 100%;\n}\n\n\n.mini {\n    height: 200px;\n    \n    overflow: hidden;\n    //margin: 10px;\n    //border-radius: 5px;\n    position: sticky !important;\n    top: 0px;\n    z-index: 100;\n}\n\n.maxi {\n    height: 100%;\n    width: 100%;\n    position: relative;\n    overflow: hidden;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
